import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function AssessmentNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Clean‑up on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xl">T</span>
          </div>
          <span
            className={`text-2xl font-bold ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            TGB Danışmanlık
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'text-gray-700 hover:text-orange-500'
                : 'text-white hover:text-orange-300'
            }`}
          >
            Ana Sayfa
          </Link>

          <Link
            to="/#services"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'text-gray-700 hover:text-orange-500'
                : 'text-white hover:text-orange-300'
            }`}
          >
            Hizmetlerimiz
          </Link>

          <Link
            to="/#about"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'text-gray-700 hover:text-orange-500'
                : 'text-white hover:text-orange-300'
            }`}
          >
            Hakkımızda
          </Link>

          <Link
            to="/#testimonials"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'text-gray-700 hover:text-orange-500'
                : 'text-white hover:text-orange-300'
            }`}
          >
            Referanslar
          </Link>

          <Link
            to="/iletisim"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'text-gray-700 hover:text-orange-500'
                : 'text-white hover:text-orange-300'
            }`}
          >
            İletişim
          </Link>

          <a
            href="#assessment-form"
            className="bg-orange-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Formu Doldurun
          </a>
        </div>
      </div>
    </nav>
  );
}
